<template>
    <div class="sip-view-page message-command-page">
        <div class="nk-block-head nk-block-head-sm sip-view-head">
            <div class="nk-block-between">
                <div class="nk-block-head-content admin-instance-page__intro">
                    <router-link
                        to="/message/inbox"
                        class="admin-instance-page__back admin-instance-page__back--pill"
                        :title="trans('message.message')"
                        :aria-label="trans('message.message')"
                    >
                        <admin-icon name="chevron-left" aria-hidden="true"></admin-icon>
                    </router-link>
                    <div class="admin-instance-page__intro-text">
                        <h3 class="nk-block-title page-title mb-0">{{ message.subject || trans('message.message') }}</h3>
                        <div class="nk-block-des text-soft" v-if="message && message.user_from">
                            <p class="mb-0">{{ message.user_from.email }} {{ trans('message.to') }} {{ message.user_to.email }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card sip-view-card saas-message-layout message-command-layout">
            <div class="row g-0">
                <message-sidebar menu="" :statistics="statistics"></message-sidebar>
                <div class="col saas-message-main message-detail-main">
                    <article class="sip-view-thread" v-if="message">
                        <div class="sip-view-thread__meta">
                            <img :src="getAvatar(message.user_from)" alt="" class="message-avatar" />
                            <div class="sip-view-thread__meta-copy">
                                <p class="sip-view-thread__route">{{ message.user_from.email+' '+trans('message.to')+' '+message.user_to.email }}</p>
                                <div class="sip-view-thread__actions">
                                    <button type="button" class="sip-view-icon-btn" :aria-label="isImportant(message) ? trans('message.important') : trans('message.mark_important')" @click="toggleImportant(message)">
                                        <i class="fas fa-star starred" v-if="isImportant(message)"></i>
                                        <i class="far fa-star" v-else></i>
                                    </button>
                                    <span class="sip-view-thread__time">{{ message.created_at | momentDateTime }}</span>
                                    <button class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" :key="message.id" type="button" :aria-label="trans('message.move_to_trash')" v-confirm="{ok: confirmDelete(message)}"><i class="fas fa-trash" aria-hidden="true"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="sip-view-thread__body" v-html="message.body"></div>
                    </article>
                    <div v-if="message.has_attachment" class="message-attachments">
                        <ul>
                            <li v-for="attachment in attachments" :key="attachment.uuid">
                                <a :href="`/message/${message.uuid}/attachment/${attachment.uuid}/download?token=${authToken}`"><i class="fas fa-paperclip"></i> {{ attachment.user_filename }}</a>
                            </li>
                        </ul>
                    </div>

                    <div class="message-replies" v-if="replies && replies.length">
                        <article v-for="reply in replies" class="sip-view-thread sip-view-thread--reply" :key="reply.id">
                            <div class="sip-view-thread__meta">
                                <img :src="getAvatar(reply.user_from)" alt="" class="message-avatar" />
                                <div class="sip-view-thread__meta-copy">
                                    <p class="sip-view-thread__route" v-if="reply">{{ reply.user_from.email+' '+trans('message.to')+' '+reply.user_to.email }}</p>
                                    <div class="sip-view-thread__actions">
                                        <button type="button" class="sip-view-icon-btn" :aria-label="isImportant(reply) ? trans('message.important') : trans('message.mark_important')" @click="toggleImportant(reply)">
                                            <i class="fas fa-star starred" v-if="isImportant(reply)"></i>
                                            <i class="far fa-star" v-else></i>
                                        </button>
                                        <span class="sip-view-thread__time">{{ reply.created_at | momentDateTime }}</span>
                                        <button class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" :key="reply.id" type="button" :aria-label="trans('message.move_to_trash')" v-confirm="{ok: confirmDelete(reply)}"><i class="fas fa-trash" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                            <div class="sip-view-thread__body" v-html="reply.body"></div>
                            <div v-if="reply.has_attachment">
                                <ul class="message-attachments__list">
                                    <li v-for="attachment in reply_attachments[reply.id]" :key="attachment.uuid">
                                        <a :href="`/message/${reply.uuid}/attachment/${attachment.uuid}/download?token=${authToken}`"><i class="fas fa-paperclip"></i> {{ attachment.user_filename }}</a>
                                    </li>
                                </ul>
                            </div>
                        </article>
                    </div>

                    <h4 class="sip-view-section-title">{{ trans('message.reply') }}</h4>

                    <form @submit.prevent="submit" @keydown="replyForm.errors.clear($event.target.name)">
                        <div class="form-group">
                            <html-editor name="body" :model.sync="replyForm.body" :isUpdate="false" @clearErrors="replyForm.errors.clear('body')"></html-editor>
                            <show-error :form-name="replyForm" prop-name="body"></show-error>
                        </div>
                        <div class="form-group">
                            <file-upload-input :button-text="trans('message.attachment')" :token="replyForm.upload_token" module="message" :clear-file="clear_message_attachment" module-id=""></file-upload-input>
                        </div>
                        <div class="saas-form-actions text-right">
                            <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid"><i class="fas fa-paper-plane"></i> {{ trans('message.send') }}</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import messageSidebar from './message-sidebar'
    import uuid from 'uuid/v4'
    import htmlEditor from '../../components/html-editor'
    import fileUploadInput from '../../components/file-upload-input'

    export default {
        components : { messageSidebar,htmlEditor,fileUploadInput },
        data() {
            return {
                uuid:this.$route.params.uuid,
                message: '',
                attachments: '',
                reply_attachments: '',
                auth_user_id: '',
                statistics: {
                    sent: 0,
                    inbox: 0,
                    draft: 0,
                    trash: 0
                },
                replyForm: new Form({
                    uuid: '',
                    body: '',
                    upload_token: ''
                }),
                clear_message_attachment: false,
                replies: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('access-message')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('message')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getStatistics();
            this.getAuthUserId();
            
            axios.get('/api/message/'+this.uuid)
                .then(response => response.data)
                .then(response => {
                    this.message = response.message;
                    this.attachments = response.attachments;
                    this.replyForm.uuid = response.message.uuid;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/message/inbox');
                });
            this.getReplies();
            this.replyForm.upload_token = this.$uuid.v4();
        },
        methods: {
            getStatistics(){
                axios.post('/api/message/statistics')
                    .then(response => response.data)
                    .then(response => {
                        this.statistics.inbox = response.inbox;
                        this.statistics.sent = response.sent;
                        this.statistics.draft = response.draft;
                        this.statistics.trash = response.trash;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getReplies(){
                axios.get('/api/message/'+this.uuid+'/reply')
                    .then(response => response.data)
                    .then(response => {
                        this.replies = response.replies;
                        this.reply_attachments = response.reply_attachments;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            isImportant(message){
                if((message.to_user_id === this.auth_user_id && message.is_important_by_receiver) || (message.from_user_id === this.auth_user_id && message.is_important_by_sender))
                    return true;
                else
                    return false;
            },
            toggleImportant(message){
                axios.post('/api/message/'+message.uuid+'/important')
                    .then(response => response.data)
                    .then(response => {
                        if(this.auth_user_id == this.message.to_user_id)
                            message.is_important_by_receiver = !message.is_important_by_receiver;
                        else
                            message.is_important_by_sender = !message.is_important_by_sender;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            submit(){
                this.replyForm.post('/api/message/reply')
                    .then(response => {
                        toastr.success(response.message);
                        this.clear_message_attachment = true;
                        this.getReplies();
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            confirmDelete(message){
                return dialog => this.deleteMessage(message);
            },
            deleteMessage(message){
                axios.post('/api/message/'+message.uuid+'/trash')
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        if(message.uuid === this.uuid)
                            this.$router.push('/message/inbox');
                        else
                            this.getReplies();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getAvatar(user){
                return helper.getAvatar(user);
            },
            getAuthUserId(){
                this.auth_user_id = helper.getAuthUser('id');
            }
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          }
        },
        computed: {
            authToken(){
                return localStorage.getItem('auth_token');
            }
        }
    }
</script>

<style scoped>
.message-detail-main {
    padding: 1rem 1.1rem 1.15rem;
    background: #ffffff;
}

.message-avatar {
    width: 2rem;
    height: 2rem;
    border-radius: 999px;
    object-fit: cover;
    border: 1px solid #e6e9ef;
}

.starred {
    color: #f59e0b;
}
</style>
